import React, { useMemo } from "react";
import { Tooltip } from "@mui/material";
import { Publications } from "modules/Publications/publications";
import { StatusChip } from "shared/components/Chips/StatusChip";

export const SurveyStatus = (props: SurveyStatusProps) => {
  const { publications = [] } = props;

  const chipProps = useMemo<{ status: string; label: string }>(() => {
    if (!publications.length) {
      return {
        status: "default",
        label: "Draft",
      };
    }

    return {
      status: "success",
      label: `Live in ${publications.length} apps`,
    };
  }, [publications]);

  const tooltipTitle = useMemo(() => {
    if (!publications.length) {
      return null;
    }

    return "Live in " + publications.map((publication) => publication.application.name).join(", ");
  }, [publications]);

  return (
    <Tooltip title={tooltipTitle}>
      <div className="_d-flex-ali-center">
        <StatusChip {...chipProps} />
      </div>
    </Tooltip>
  );
};

interface SurveyStatusProps {
  publications?: Publications.Publication[];
}
